<template>
  <div class="gallery">
    <div class="container">
      <div class="heading mb-5 text-center with-border" data-aos="fade-down">
        <h2 class="title text-uppercase text-teal-dark">Gallery</h2>
        <!-- <div class="sub-title">We Are Getting Married</div> -->
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 mb-3">
          <iframe width="100%" height="260" src="https://www.youtube.com/embed/2zZXOS8zhvE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class=""
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="d-flex flex-wrap row justify-content-center">
            <div
              class=""
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}&tr=w-600`" lazy />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
      <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
      <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="control left" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="control right" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{
                preview.copyright.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1,
      },
      gallery: [
        {
          className: "col-md-12",
          items: [
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4559.jpg?updatedAt=1632302557816",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-12 offset-md-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4570.jpg?updatedAt=1632302558774",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-12"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4654.jpg?updatedAt=1632302565217",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4600.jpg?updatedAt=1632302562489",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-5 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4611.jpg?updatedAt=1632302563678",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4649.jpg?updatedAt=1632302564342",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },

            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4596.jpg?updatedAt=1632302561498",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-5 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4576.jpg?updatedAt=1632302560689",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-7 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4573.jpg?updatedAt=1632302559682",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-7 order-md-0 offset-md-1"
            },
            {
              full:
                "https://ik.imagekit.io/aryraditya/ceremonyku/tirta-suci/IMG_4560.jpg?updatedAt=1632302557931",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-7 order-md-0"
            },
          ],
        },
      ],
      preview: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    },
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach((items) => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map((item) => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    },
  },
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
